@if (showClosePopup()) {
  <div class="onfido-close">
    <div class="bp-modal v-align">
      <div class="bp-modal-body-section mod-wide p-30">
        <div class="center-block text-center">
          <h4 class="font-size-24 no-hyphens text-left">{{ "close_window?" | translate }}</h4>
          <p class="font-size-15 text-left pb-30">{{ "unsaved_data_will_get_lost" | translate }}</p>
          <div class="mt-30 items-center justify-end">
            <button
              type="button"
              class="btn btn-link mr-10 font-size-15 color-black font-medium"
              (click)="answer(false)">
              {{ "modal_confirm_no_option" | translate }}
            </button>
            <button type="button" class="btn btn-primary font-size-15 pl-20 pr-20" (click)="answer(true)">
              {{ "modal_confirm_yes_option" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
